export default {
	getItem(key: string) {
	  const item = localStorage.getItem(key);
		return item ? JSON.parse(item) : item;
	},
	setItem(key: string, value: object | string) {
		localStorage.setItem(key, JSON.stringify(value));
	},
	removeItem(key: string) {
		localStorage.removeItem(key);
	}
};
